"use strict";

var _classCallCheck = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _slicedToArray = require("/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Timer = exports.getHighResolutionTime = exports.getLowResolutionTime = exports.getTime = exports.getBrowserTime = exports.supportsHighResolutionTime = void 0;

var Time_1 = require("./Time");

var SemanticMetrics_1 = require("../SemanticMetrics");

var supportsHighResolutionTime = function supportsHighResolutionTime() {
  return process && typeof process.hrtime === 'function';
};

exports.supportsHighResolutionTime = supportsHighResolutionTime;

var getBrowserTime = function getBrowserTime() {
  return typeof performance !== 'undefined' ? performance.now() : Date.now();
};

exports.getBrowserTime = getBrowserTime;

var getTime = function getTime() {
  return exports.supportsHighResolutionTime() ? process.hrtime() : exports.getBrowserTime();
};

exports.getTime = getTime;

var getLowResolutionTime = function getLowResolutionTime(startTime) {
  var millis = exports.getTime() - startTime;
  var time = Time_1.Time.fromMillis(millis);
  return {
    nanoseconds: SemanticMetrics_1.asNanoseconds(time.asNanos()),
    milliseconds: time.asMillis(),
    seconds: time.asSeconds()
  };
};

exports.getLowResolutionTime = getLowResolutionTime;

var getHighResolutionTime = function getHighResolutionTime(startTime) {
  var _process$hrtime = process.hrtime(startTime),
      _process$hrtime2 = _slicedToArray(_process$hrtime, 2),
      diffSeconds = _process$hrtime2[0],
      diffNanoseconds = _process$hrtime2[1];

  var nanoseconds = diffSeconds * 1e9 + diffNanoseconds;
  var milliseconds = nanoseconds / 1e6;
  var seconds = nanoseconds / 1e9;
  return {
    nanoseconds: SemanticMetrics_1.asNanoseconds(nanoseconds),
    milliseconds: milliseconds,
    seconds: seconds
  };
};

exports.getHighResolutionTime = getHighResolutionTime;

var Timer =
/*#__PURE__*/
function () {
  function Timer(startTime) {
    _classCallCheck(this, Timer);

    this.startTime = startTime;
  }

  _createClass(Timer, [{
    key: "end",
    value: function end() {
      if (exports.supportsHighResolutionTime()) {
        return exports.getHighResolutionTime(this.startTime);
      }

      return exports.getLowResolutionTime(this.startTime);
    }
  }], [{
    key: "start",
    value: function start() {
      return new Timer(exports.getTime());
    }
  }]);

  return Timer;
}();

exports.Timer = Timer;